import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule} from '@angular/core';
import { Cms } from '@impact/data';
import { UtilsModule } from '../../utils/utils.module';
import { quotes } from '../../../icons';

@Component({
    selector: 'app-quote-spot',
    template: `
        <div class="quote-spot">
            <span class="quote-spot__svg">
                ${quotes}
            </span>
            <div class="quote-spot__rich-text h4" [innerHTML]="data?.quoteText | safe: 'html'" appInterceptLinks></div>
            <div class="quote-spot__source-text">- {{ data?.quoteSourceName }}</div>
        </div>
    `,

    changeDetection: ChangeDetectionStrategy.OnPush,
})
class quoteSpotComponent {
    static ref = 'quotespot';
    @Input() data: Cms.QuoteSpot;
}

@NgModule({
    declarations: [quoteSpotComponent],
    imports: [
        CommonModule,
        UtilsModule
    ]
})
class quoteSpotModule {}

export const LazySpotComponent = quoteSpotComponent;
